// extracted by mini-css-extract-plugin
module.exports = {"landingScreen":"LandingScreenAnim_landingScreen__1oQgI","animate":"LandingScreenAnim_animate__3DrhR"};